import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner, Modal, ModalBody } from "reactstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import {
  formatAmount,
  getTotalAmount,
  HandlePurchaseRequestStatus,
  handleUnderInBudget,
} from "../../../utility/CommonFunctions";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";

import MainHeading from "../../../components/comman/MainHeading";
import CommonTable from "../../../components/comman/CommonTable";
import Logs from "../../Logs/Logs";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";

import DocumentIcon from "../../../components/Icons/DocumentIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import DownloadIcon from "../../../components/Icons/DownloadIcon";
import CheckIcon from "../../../components/Icons/CheckIcon";
import CrossIcon from "../../../components/Icons/CrossIcon";

export default function PurchaseOrderDetail() {
  let { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.root.userDetails);
  const [dataLoading, setDataLoading] = useState(false);
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [pageStates, setPageStates] = useState({
    purchaseData: {},
    siteBudget: [],
    loading: false,
    IncreaseLoading: false,
    downloadLoading: false,
  });
  const [pageStatesPT, setPageStatesPT] = useState({
    tableLoader: false,
    PaymentTicketList: [],
    type: "AgainstPO",
  });
  const [pageStatesGRN, setPageStatesGRN] = useState({
    tableLoader: false,
    GRN_List: [],
    type: "AgainstPO",
  });
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };

  const [selectedDocument, setSelectedDocument] = useState();
  const [documentModal, setDocumentModal] = useState(false);
  const toggleDocumentModal = () => {
    setDocumentModal(!documentModal);
  };

  const [increaseBudgetModal, setIncreaseBudgetModal] = useState(false);
  const toggleIncreaseBudgetModal = () => {
    setIncreaseBudgetModal(!increaseBudgetModal);
  };

  const handleDocumentClick = (doc) => {
    setSelectedDocument({ url: doc?.url });
    toggleDocumentModal();
  };

  useEffect(() => {
    GetPurchaseDetail();
  }, []);

  useEffect(() => {
    if (
      pageStates?.purchaseData?.status?.includes("Approved") ||
      pageStates?.purchaseData?.status?.includes("Director Created") ||
      pageStates?.purchaseData?.status?.includes("Short Closed")
    ) {
      GetPaymentTicket();
    }
  }, [pageStates?.purchaseData?.status]);

  useEffect(() => {
    if (
      pageStates?.purchaseData?.canViewGRN &&
      userDetails?.designation?.canCreate?.includes("grn")
    ) {
      GetGRN_List();
    }
  }, [pageStates?.purchaseData?.canViewGRN, userDetails]);

  const GetPurchaseDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_purchase_detail + `purchaseId=${id}`;
    setDataLoading(true);
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          purchaseData: response?.data,
        }));

        if (
          response?.data?.canChangeStatus ||
          response?.data?.status?.includes("Hold")
        ) {
          let API2 =
            apiUrl?.get_site_budget +
            `siteId=${response?.data?.purchaserequest?.siteId}&type=${
              response?.data?.purchaserequest?.type === "supplyRequest"
                ? "supplyBudget"
                : "serviceBudget"
            }&financialYear=${response?.data?.financialYear}`;
          callApi(API2, options).then((res) => {
            if (res?.status === true) {
              setPageStates((prev) => ({
                ...prev,
                siteBudget:
                  response?.data?.purchaserequest?.purchaserequestexpenseheads
                    ?.map((budget) => {
                      const matchingExpense = res?.data?.find(
                        (item) =>
                          item?.expensehead?.id === budget?.expensehead?.id,
                      );

                      if (!matchingExpense) return null;

                      const expenseHead =
                        response?.data?.purchaserequest?.purchaserequestexpenseheads?.find(
                          (exp) =>
                            exp?.expensehead?.id ===
                            matchingExpense?.expensehead?.id,
                        );

                      if (!expenseHead) return null;

                      const amount =
                        expenseHead?.supplyrequestitems?.reduce((sum, item) => {
                          return (
                            sum +
                            getTotalAmount(
                              item,
                              response?.data?.purchaserequest?.type,
                            )
                          );
                        }, 0) || 0;

                      const differenceAmount =
                        +matchingExpense?.expectedAmount -
                        +matchingExpense?.freezedAmount;
                      const { underBudget, difference } = handleUnderInBudget(
                        amount,
                        differenceAmount,
                      );

                      return {
                        ...matchingExpense,
                        underBudget,
                        difference: differenceAmount,
                        isLoading: false,
                        differenceAmount: difference,
                      };
                    })
                    .filter(Boolean) || [],
              }));
            } else {
              toast.error(res?.message);
            }
          });
        }
      } else {
        toast.error(response?.message);
      }
    });
  };

  const GetPaymentTicket = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_payment_ticket +
      MainFilterHandler(pageStatesPT) +
      `&purchaseId=${id}`;
    setPageStatesPT((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStatesPT((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.paymentTicket?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          paymentDate: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
          paymentStatus:
            item?.remainingAmount === item?.totalAmount
              ? 0
              : item?.remainingAmount === 0
              ? 1
              : 2,
          grandTotal: formatAmount(item?.totalAmount),
          vendorName: item?.purchase?.vendor?.name,
          expenseName:
            item?.paymentticketexpenseheads[0]?.expensehead?.name +
            `${
              item?.paymentticketexpenseheads?.length > 1
                ? ` + ${item?.paymentticketexpenseheads?.length - 1}`
                : ""
            }`,
          remaining: formatAmount(item?.remainingAmount),
          paidAmount: formatAmount(item?.totalAmount - item?.remainingAmount),
        }));
        setPageStatesPT((pre) => ({
          ...pre,
          PaymentTicketList: newData,
        }));
      }
    });
  };

  const GetGRN_List = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_GRN + MainFilterHandler(pageStatesGRN) + `&purchaseId=${id}`;
    setPageStatesGRN((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStatesGRN((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.grn?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          createdON: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
        }));
        setPageStatesGRN((pre) => ({
          ...pre,
          GRN_List: newData,
        }));
      }
    });
  };

  const getAmountWithGst = (gst, total) => {
    return formatAmount((Number(gst) * total) / 100 + total);
  };

  const handleReqStatus = (status, reason = "") => {
    let postData = {
      status: status === "Short Closed" ? "Closed" : status,
      ...((status === "Rejected" || status === "Short Closed") && {
        rejectReason: reason,
      }),
      ...(status === "Hold" && {
        holdReason: reason,
        reason: reason,
      }),
    };
    const option = {
      method: "POST",
      data: postData,
    };
    setPageStates((pre) => ({
      ...pre,
      loading: true,
    }));
    callApi(apiUrl.update_purchase + `?purchaseId=${id}`, option).then(
      (res) => {
        setPageStates((pre) => ({
          ...pre,
          loading: false,
        }));
        toggle();
        if (res?.status) {
          toast.success(
            res?.message ||
              (status === "Short Closed"
                ? "PO Short Closed"
                : "Request Updated"),
          );
          if (status !== "Short Closed" && status !== "Hold") {
            navigate(-1);
          }
          GetPurchaseDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
      },
    );
  };

  const handleIncreaseSiteBudget = () => {
    if (pageStates?.purchaseData?.isInBudgetRequest) {
      toast.info("Request already sent!");
      return;
    }
    const postData = {
      purchaseId: id,
      budgetRequest: pageStates?.siteBudget
        ?.filter((budget) => !budget?.underBudget)
        ?.map((budget) => ({
          amount: Math.abs(budget?.differenceAmount),
          expenseHeadId: budget?.expenseheadId,
        })),
      siteId: pageStates.purchaseData?.purchaserequest?.site?.id,
    };
    const option = {
      method: "POST",
      data: postData,
    };
    setPageStates((pre) => ({
      ...pre,
      IncreaseLoading: true,
    }));

    callApi(apiUrl.increase_site_budget, option).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        IncreaseLoading: false,
      }));
      if (res?.status) {
        toast.success("Request Sent");
        toggleIncreaseBudgetModal();
        GetPurchaseDetail();
      } else {
        toast.error(res?.message);
      }
    });
  };

  const HandleView = (data) => {
    navigate(RoutesLink.payment_tickets_details + `/againstPo/${data?.id}`);
  };

  const HandleViewGRN = (data) => {
    navigate(RoutesLink.grn_detail + `/${data?.id}`);
  };

  const TableHeadingAgainstPo = [
    { value: "ticketNumber", label: "Ticket Number" },
    { value: "siteName", label: "Site Name" },
    { value: "paymentDate", label: "Date" },
    { value: "expenseName", label: "Expense Name" },
    { value: "createdBy", label: "Created By" },
    { value: "vendorName", label: "Vendor Name" },
    { value: "grandTotal", label: "Total Amount" },
    { value: "remaining", label: "Payable Amount" },
    { value: "paidAmount", label: "Paid Amount" },
    { value: "paymentStatus", label: "Payment Status" },
    { value: "paymentTicketStatus", label: "Status" },
  ];

  const TableHeadingForGRN = [
    { value: "grnNumber", label: "GRN Number" },
    { value: "siteName", label: "Site Name" },
    { value: "createdON", label: "Date" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentTicketStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const ActionDataForGRN = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleViewGRN,
    },
  ];

  const HandleDownloadPO = async () => {
    const API = `${apiUrl?.generate_purchase_order}purchaseId=${id}`;

    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));
      const response = await callApi(API, { method: "GET" });
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Purchase Order_${
          pageStates?.purchaseData?.purchaseNumber || "Purchase Order"
        }.pdf`;

        const fileResponse = await fetch(fileUrl);

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // clean up
      } else {
        toast.error(response?.message || "Failed to fetch file URL");
      }
    } catch (err) {
      console.error(err);
      toast.error("Download failed. Please try again.");
    }
  };

  const calculateGrandTotal = () => {
    let grandTotal = 0;
    pageStates?.purchaseData?.purchaserequest?.purchaserequestexpenseheads?.forEach(
      (exHead) => {
        exHead?.supplyrequestitems?.forEach((item) => {
          const amount = getTotalAmount(
            item,
            pageStates?.purchaseData?.purchaserequest?.type,
          );
          const gstVal = parseFloat(item?.gst) || 0;
          const gstAmount = (amount * gstVal) / 100;
          grandTotal += amount + gstAmount;
        });
      },
    );
    return grandTotal;
  };

  // Conditions
  const canChangeStatus = Boolean(
    (pageStates?.purchaseData?.canChangeStatus ||
      pageStates?.purchaseData?.status?.includes("Hold")) &&
      pageStates?.siteBudget?.length > 0,
  );

  const canHold = Boolean(
    canChangeStatus && !pageStates?.purchaseData?.status?.includes("Hold"),
  );

  const canApprove = Boolean(
    canChangeStatus &&
      pageStates?.siteBudget?.every((item) => item?.underBudget === true),
  );

  const canShortClose = Boolean(pageStates?.purchaseData?.canShortClose);

  const hasAnyAction = canChangeStatus || canShortClose;

  const totalItemsCount =
    pageStates?.purchaseData?.purchaserequest?.purchaserequestexpenseheads?.reduce(
      (sum, head) => sum + (head?.supplyrequestitems?.length || 0),
      0,
    ) || 0;

  const parseGtcList = () => {
    try {
      if (!pageStates?.purchaseData?.gtc) return [];
      const parsed = JSON.parse(pageStates?.purchaseData?.gtc);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const renderActionButtons = (size = "md") => {
    const isSmall = size === "sm";
    const btnClass = isSmall ? "btn btn-sm" : "btn";

    return (
      <div className="d-flex align-items-center flex-wrap gap-2">
        {/* Short Close Button */}
        {canShortClose && (
          <button
            onClick={() => {
              setModalType("shortClose");
              toggle();
            }}
            className={`${btnClass} btn-outline-danger d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2`}
            type="button"
            title="Short Close Purchase Order"
          >
            <span>⛔</span>
            <span>Short Close</span>
          </button>
        )}

        {/* Reject Button */}
        {canChangeStatus && (
          <button
            onClick={() => {
              setModalType("reject");
              toggle();
            }}
            className={`${btnClass} btn-outline-danger d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2`}
            type="button"
            title="Reject Purchase Order"
          >
            <CrossIcon width="12" height="12" />
            <span>Reject</span>
          </button>
        )}

        {/* Hold Button */}
        {canHold && (
          <button
            onClick={() => {
              setModalType("hold");
              toggle();
            }}
            className={`${btnClass} btn-outline-warning d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2`}
            type="button"
            title="Put Purchase Order on Hold"
          >
            <span>⏸</span>
            <span>Hold</span>
          </button>
        )}

        {/* Approve Button */}
        {canApprove && (
          <button
            onClick={() => {
              setModalType("approve");
              toggle();
            }}
            className={`${btnClass} btn-success d-inline-flex align-items-center gap-1.5 fw-semibold px-3.5 py-2 text-white shadow-sm`}
            style={{ background: "#059669", borderColor: "#059669" }}
            type="button"
            title="Approve Purchase Order"
          >
            <CheckIcon />
            <span>Approve</span>
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      {dataLoading && <BgBlurLoader />}

      <div className="content container-fluid pb-5">
        {/* Main Header with Top Action Cluster */}
        <MainHeading title="Purchase Order Detail" showBackButton={true}>
          <div className="d-flex align-items-center gap-2">
            {pageStates?.purchaseData?.canCreateGRN &&
              userDetails?.designation?.canCreate?.includes("grn") && (
                <button
                  type="button"
                  className="btn btn-outline-primary d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2 shadow-sm"
                  onClick={() =>
                    navigate(RoutesLink?.createGrn, {
                      state: {
                        data: pageStates?.purchaseData,
                        type: "Create",
                      },
                    })
                  }
                >
                  <span>📦</span>
                  <span>Create GRN</span>
                </button>
              )}

            {pageStates?.purchaseData?.canDownloadPO && (
              <button
                type="button"
                className="btn btn-primary d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2 shadow-sm text-white"
                style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
                onClick={() => HandleDownloadPO()}
                disabled={pageStates?.downloadLoading}
              >
                {pageStates?.downloadLoading ? (
                  <Spinner size="sm" />
                ) : (
                  <>
                    <DownloadIcon />
                    <span>Download PO</span>
                  </>
                )}
              </button>
            )}
          </div>
        </MainHeading>

        {/* Hold Alert Notice Banner */}
        {(pageStates?.purchaseData?.status?.includes("Hold") ||
          pageStates?.purchaseData?.holdReason) && (
          <div
            className="alert border-0 rounded-3 p-3 mb-4 d-flex align-items-start gap-3 shadow-sm"
            style={{
              background: "#fffbeb",
              borderLeft: "4px solid #f59e0b",
            }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                background: "#fef3c7",
                color: "#b45309",
                width: "36px",
                height: "36px",
                fontSize: "14px",
              }}
            >
              ⏸
            </div>
            <div className="flex-grow-1">
              <div
                className="fw-bold text-dark mb-1"
                style={{ fontSize: "14px" }}
              >
                Purchase Order is currently on Hold
              </div>
              <div style={{ color: "#78350f", fontSize: "13px" }}>
                <strong>Reason: </strong>
                {pageStates?.purchaseData?.holdReason ||
                  "This purchase order is currently placed on hold pending review."}
              </div>
            </div>
            <span
              className="badge rounded-pill px-3 py-1 flex-shrink-0"
              style={{
                background: "#fde68a",
                color: "#92400e",
                fontWeight: 600,
              }}
            >
              {pageStates?.purchaseData?.status}
            </span>
          </div>
        )}

        {/* Rejected Alert Notice Banner */}
        {pageStates?.purchaseData?.rejectReason && (
          <div
            className="alert border-0 rounded-3 p-3 mb-4 d-flex align-items-start gap-3 shadow-sm"
            style={{
              background: "#fef2f2",
              borderLeft: "4px solid #ef4444",
            }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                background: "#fee2e2",
                color: "#dc2626",
                width: "36px",
                height: "36px",
                fontSize: "14px",
              }}
            >
              ✕
            </div>
            <div className="flex-grow-1">
              <div
                className="fw-bold text-dark mb-1"
                style={{ fontSize: "14px" }}
              >
                Purchase Order Rejected
              </div>
              <div style={{ color: "#991b1b", fontSize: "13px" }}>
                <strong>Reason: </strong>
                {pageStates?.purchaseData?.rejectReason}
              </div>
            </div>
            <span
              className="badge rounded-pill px-3 py-1 flex-shrink-0"
              style={{
                background: "#fecdd3",
                color: "#9f1239",
                fontWeight: 600,
              }}
            >
              {pageStates?.purchaseData?.status}
            </span>
          </div>
        )}

        {/* Pending Budget Request Warning Banner */}
        {pageStates?.purchaseData?.isInBudgetRequest && (
          <div
            className="alert border-0 rounded-3 p-3 mb-4 d-flex align-items-center gap-3 shadow-sm"
            style={{
              background: "#fffbeb",
              borderLeft: "4px solid #f59e0b",
            }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                background: "#fef3c7",
                color: "#b45309",
                width: "36px",
                height: "36px",
                fontSize: "14px",
              }}
            >
              ⚠️
            </div>
            <div
              className="flex-grow-1"
              style={{ color: "#78350f", fontSize: "13.5px" }}
            >
              <strong>Pending Budget Request: </strong>
              There is a pending budget request for this PO. First approve or
              reject that request before you can approve or reject this PO.
            </div>
          </div>
        )}

        {/* Master Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                  style={{
                    background: "#f1f5f9",
                    color: "#334155",
                    width: "48px",
                    height: "48px",
                    fontSize: "20px",
                  }}
                >
                  📑
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {pageStates.purchaseData?.purchaseNumber || "--"}
                    </h3>
                    <span
                      className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1"
                      style={{
                        fontSize: "12px",
                        background:
                          pageStates?.purchaseData?.purchaserequest?.type ===
                          "supplyRequest"
                            ? "#eff6ff"
                            : "#faf5ff",
                        color:
                          pageStates?.purchaseData?.purchaserequest?.type ===
                          "supplyRequest"
                            ? "#1d4ed8"
                            : "#7e22ce",
                        border: `1px solid ${
                          pageStates?.purchaseData?.purchaserequest?.type ===
                          "supplyRequest"
                            ? "#bfdbfe"
                            : "#e9d5ff"
                        }`,
                      }}
                    >
                      <span>
                        {pageStates?.purchaseData?.purchaserequest?.type ===
                        "supplyRequest"
                          ? "📦"
                          : "⚙️"}
                      </span>
                      <span>
                        {pageStates?.purchaseData?.purchaserequest?.type ===
                        "supplyRequest"
                          ? "Supply Order"
                          : "Service Order"}
                      </span>
                    </span>
                    <div>
                      {HandlePurchaseRequestStatus(
                        pageStates.purchaseData?.status,
                      )}
                    </div>
                  </div>
                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📍</span>
                      <span>
                        <strong>Site:</strong>{" "}
                        {pageStates.purchaseData?.purchaserequest?.site?.name ||
                          "--"}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📅</span>
                      <span>
                        <strong>Date:</strong>{" "}
                        {pageStates.purchaseData?.purchaseDate
                          ? moment(
                              pageStates.purchaseData?.purchaseDate,
                            ).format("DD-MM-YYYY")
                          : "--"}
                      </span>
                    </span>
                    {pageStates?.purchaseData?.purchaserequest
                      ?.requestNumber && (
                      <>
                        <span>•</span>
                        <span className="d-inline-flex align-items-center gap-1">
                          <span>📋</span>
                          <span>
                            <strong>PR:</strong>{" "}
                            {
                              pageStates?.purchaseData?.purchaserequest
                                ?.requestNumber
                            }
                          </span>
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Quick Quantitative Stats */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "110px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Amount
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(calculateGrandTotal())}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "110px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Remaining Amount
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(
                      pageStates?.purchaseData?.remainingAmount || 0,
                    )}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "85px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Items
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {totalItemsCount}
                  </div>
                </div>
              </div>
            </div>

            {/* Key Information Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Site Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={
                      pageStates.purchaseData?.purchaserequest?.site?.name
                    }
                    style={{ fontSize: "13.5px" }}
                  >
                    {pageStates.purchaseData?.purchaserequest?.site?.name ||
                      "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Project / O&M Site
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Financial Year
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {pageStates?.purchaseData?.financialYear || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Fiscal Cycle
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    GST Type
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {pageStates?.purchaseData?.gstType || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Tax Specification
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Created By
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={pageStates?.purchaseData?.user?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {pageStates?.purchaseData?.user?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    {pageStates?.purchaseData?.user?.designation?.name ||
                      "Order Author"}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Vendor Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={pageStates.purchaseData?.vendor?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {pageStates.purchaseData?.vendor?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Supplier Contact
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Vendor Firm
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={pageStates.purchaseData?.vendor?.firmName}
                    style={{ fontSize: "13.5px" }}
                  >
                    {pageStates.purchaseData?.vendor?.firmName || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Supplier Entity
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Payment Terms
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={pageStates?.purchaseData?.paymentTerms}
                    style={{ fontSize: "13.5px" }}
                  >
                    {pageStates?.purchaseData?.paymentTerms || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Commercial Term
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Documents Checklist for Billing
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={parseGtcList().join(", ")}
                    style={{ fontSize: "13.5px" }}
                  >
                    {parseGtcList().length > 0
                      ? parseGtcList().join(", ")
                      : "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Required Billing Papers
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Site Budgets Section (when applicable) */}
        {(pageStates?.purchaseData?.canChangeStatus ||
          pageStates?.purchaseData?.status?.includes("Hold")) &&
          pageStates?.siteBudget &&
          pageStates?.siteBudget?.length > 0 && (
            <div
              className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                    style={{ background: "#f1f5f9", color: "#475569" }}
                  >
                    <span style={{ fontSize: "15px" }}>📊</span>
                  </div>
                  <div>
                    <h5
                      className="mb-0 fw-bold text-dark"
                      style={{ fontSize: "15px" }}
                    >
                      Site Budgets
                    </h5>
                  </div>
                </div>
                {location?.state?.isShow !== false &&
                  pageStates?.siteBudget?.some(
                    (item) => item?.underBudget === false,
                  ) &&
                  !pageStates?.purchaseData?.isInBudgetRequest &&
                  userDetails?.type !== 2 && (
                    <button
                      className="btn btn-warning btn-sm d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-1.5 shadow-sm"
                      type="button"
                      disabled={pageStates.IncreaseLoading}
                      onClick={() => toggleIncreaseBudgetModal()}
                    >
                      {pageStates?.IncreaseLoading ? (
                        <Spinner size="sm" />
                      ) : (
                        <>
                          <span>📈</span>
                          <span>Increase Budget</span>
                        </>
                      )}
                    </button>
                  )}
              </div>
              <div className="card-body p-4">
                <div className="row g-3">
                  {pageStates.siteBudget.map((item, i) => (
                    <div key={i} className="col-12 col-md-6 col-lg-4">
                      <div
                        className="p-3 rounded-2 h-100"
                        style={{
                          background: item?.underBudget ? "#f8fafc" : "#fff5f5",
                          border: item?.underBudget
                            ? "1px solid #e2e8f0"
                            : "1px solid #fed7d7",
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <h6
                            className="mb-0 fw-bold text-dark text-truncate"
                            title={item?.expensehead?.name}
                            style={{ fontSize: "14px" }}
                          >
                            {item?.expensehead?.name || "--"}
                          </h6>
                          {item?.underBudget ? (
                            <span
                              className="badge rounded-pill px-2.5 py-1"
                              style={{
                                background: "#f0fdf4",
                                color: "#166534",
                                border: "1px solid #bbf7d0",
                                fontSize: "11px",
                                fontWeight: 600,
                              }}
                            >
                              Under Budget
                            </span>
                          ) : (
                            <span
                              className="badge rounded-pill px-2.5 py-1"
                              style={{
                                background: "#fef2f2",
                                color: "#991b1b",
                                border: "1px solid #fecaca",
                                fontSize: "11px",
                                fontWeight: 600,
                              }}
                            >
                              Out of Budget
                            </span>
                          )}
                        </div>

                        <div
                          className="d-flex flex-column gap-1.5 mt-3 pt-2 border-top"
                          style={{
                            borderColor: item?.underBudget
                              ? "#f1f5f9"
                              : "#fed7d7",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-between small">
                            <span className="text-secondary">
                              Allocated Budget:
                            </span>
                            <span className="fw-semibold text-dark">
                              {formatAmount(item?.expectedAmount) || "--"}
                            </span>
                          </div>
                          <div className="d-flex align-items-center justify-content-between small">
                            <span className="text-secondary">
                              Remaining Budget:
                            </span>
                            <span
                              className={`fw-bold ${
                                item?.underBudget
                                  ? "text-success"
                                  : "text-danger"
                              }`}
                            >
                              {formatAmount(item?.difference) || "--"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

        {/* Material / Service Items Tables grouped by Expense Head */}
        {pageStates?.purchaseData?.purchaserequest
          ?.purchaserequestexpenseheads &&
        pageStates?.purchaseData?.purchaserequest?.purchaserequestexpenseheads
          ?.length > 0 ? (
          pageStates.purchaseData.purchaserequest.purchaserequestexpenseheads.map(
            (exHead, index) => {
              let totalAmount = 0;
              let totalAmountWithGST = 0;
              const isService =
                pageStates?.purchaseData?.purchaserequest?.type ===
                "serviceRequest";

              return (
                <div
                  className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
                  key={exHead.id || index}
                  style={{ background: "#ffffff" }}
                >
                  <div
                    className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                    style={{ borderColor: "#f1f5f9" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                        style={{ background: "#f1f5f9", color: "#475569" }}
                      >
                        <span
                          style={{
                            fontSize: "15px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: 1,
                            transform: "translateY(-1.5px)",
                          }}
                        >
                          🏷️
                        </span>
                      </div>
                      <div>
                        <div
                          className="text-muted text-uppercase"
                          style={{
                            fontSize: "10.5px",
                            fontWeight: 700,
                            letterSpacing: "0.06em",
                          }}
                        >
                          {!isService ? "Expense Head" : "Service Type"}
                        </div>
                        <h5
                          className="mb-0 fw-bold text-dark"
                          style={{ fontSize: "15px" }}
                        >
                          {exHead?.expensehead?.name || "--"}
                        </h5>
                      </div>
                    </div>
                    <span
                      className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
                      style={{ fontSize: "12px", fontWeight: 600 }}
                    >
                      {exHead?.supplyrequestitems?.length || 0}{" "}
                      {exHead?.supplyrequestitems?.length === 1
                        ? "Line Item"
                        : "Line Items"}
                    </span>
                  </div>

                  <div className="table-responsive">
                    <table
                      className="table pr-detail-table align-middle mb-0"
                      style={{ borderCollapse: "separate", borderSpacing: "0" }}
                    >
                      <thead style={{ background: "#f8fafc" }}>
                        <tr>
                          <th
                            style={{
                              width: "50px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            #
                          </th>
                          <th
                            style={{
                              minWidth: "200px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Item
                          </th>
                          <th
                            style={{
                              width: "120px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            HSN Code
                          </th>
                          <th
                            style={{
                              width: "120px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Quantity
                          </th>
                          {isService && (
                            <th
                              style={{
                                width: "110px",
                                padding: "12px 16px",
                                fontSize: "11px",
                                fontWeight: 700,
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                color: "#64748b",
                              }}
                            >
                              Month
                            </th>
                          )}
                          <th
                            className="text-end"
                            style={{
                              width: "120px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Rate
                          </th>
                          <th
                            className="text-end"
                            style={{
                              width: "130px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Amount
                          </th>
                          {pageStates?.purchaseData?.gstType === "IGST" && (
                            <th
                              className="text-end"
                              style={{
                                width: "140px",
                                padding: "12px 16px",
                                fontSize: "11px",
                                fontWeight: 700,
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                color: "#64748b",
                              }}
                            >
                              IGST
                            </th>
                          )}
                          {pageStates?.purchaseData?.gstType ===
                            "CGST + SGST" && (
                            <>
                              <th
                                className="text-end"
                                style={{
                                  width: "130px",
                                  padding: "12px 16px",
                                  fontSize: "11px",
                                  fontWeight: 700,
                                  textTransform: "uppercase",
                                  letterSpacing: "0.05em",
                                  color: "#64748b",
                                }}
                              >
                                CGST
                              </th>
                              <th
                                className="text-end"
                                style={{
                                  width: "130px",
                                  padding: "12px 16px",
                                  fontSize: "11px",
                                  fontWeight: 700,
                                  textTransform: "uppercase",
                                  letterSpacing: "0.05em",
                                  color: "#64748b",
                                }}
                              >
                                SGST
                              </th>
                            </>
                          )}
                          <th
                            className="text-end"
                            style={{
                              width: "160px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Amount With GST
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {exHead?.supplyrequestitems?.length > 0 ? (
                          exHead.supplyrequestitems.map((item, i) => {
                            const amount = getTotalAmount(
                              item,
                              pageStates?.purchaseData?.purchaserequest?.type,
                            );

                            const gstVal = parseFloat(item?.gst) || 0;
                            const gstAmount = (amount * gstVal) / 100;

                            totalAmount += amount;
                            totalAmountWithGST += gstAmount;

                            return (
                              <tr
                                key={i}
                                style={{ borderBottom: "1px solid #f1f5f9" }}
                              >
                                <td
                                  style={{
                                    padding: "14px 16px",
                                    fontSize: "13px",
                                    color: "#94a3b8",
                                    fontWeight: 600,
                                  }}
                                >
                                  {i + 1}
                                </td>
                                <td style={{ padding: "14px 16px" }}>
                                  <div
                                    className="fw-semibold text-dark"
                                    style={{ fontSize: "13.5px" }}
                                  >
                                    {item?.item?.name || "--"}
                                  </div>
                                </td>
                                <td
                                  style={{
                                    padding: "14px 16px",
                                    fontSize: "13px",
                                    color: "#475569",
                                  }}
                                >
                                  {item?.item?.hsnCode || "--"}
                                </td>
                                <td style={{ padding: "14px 16px" }}>
                                  <span className="fw-medium text-dark">
                                    {item?.updatedQuantity}
                                  </span>{" "}
                                  <span
                                    className="badge rounded-pill bg-light text-secondary border px-2 py-0.5"
                                    style={{ fontSize: "11.5px" }}
                                  >
                                    {item?.item?.unit || "--"}
                                  </span>
                                </td>
                                {isService && (
                                  <td
                                    style={{
                                      padding: "14px 16px",
                                      fontSize: "13px",
                                      color: "#475569",
                                    }}
                                  >
                                    {item?.month || "--"}
                                  </td>
                                )}
                                <td
                                  className="text-end"
                                  style={{
                                    padding: "14px 16px",
                                    fontSize: "13.5px",
                                    color: "#475569",
                                    fontWeight: 500,
                                  }}
                                >
                                  {formatAmount(item?.rate)}
                                </td>
                                <td
                                  className="text-end"
                                  style={{
                                    padding: "14px 16px",
                                    fontSize: "13.5px",
                                    color: "#475569",
                                    fontWeight: 500,
                                  }}
                                >
                                  {formatAmount(amount)}
                                </td>
                                {pageStates?.purchaseData?.gstType ===
                                  "IGST" && (
                                  <td
                                    className="text-end"
                                    style={{
                                      padding: "14px 16px",
                                      fontSize: "13px",
                                      color: "#475569",
                                    }}
                                  >
                                    <div>
                                      {formatAmount((amount * gstVal) / 100)}
                                    </div>
                                    <div
                                      className="text-muted"
                                      style={{ fontSize: "11px" }}
                                    >
                                      ({gstVal}%)
                                    </div>
                                  </td>
                                )}
                                {pageStates?.purchaseData?.gstType ===
                                  "CGST + SGST" && (
                                  <>
                                    <td
                                      className="text-end"
                                      style={{
                                        padding: "14px 16px",
                                        fontSize: "13px",
                                        color: "#475569",
                                      }}
                                    >
                                      <div>
                                        {formatAmount(
                                          (amount * gstVal) / 2 / 100,
                                        )}
                                      </div>
                                      <div
                                        className="text-muted"
                                        style={{ fontSize: "11px" }}
                                      >
                                        ({gstVal / 2}%)
                                      </div>
                                    </td>
                                    <td
                                      className="text-end"
                                      style={{
                                        padding: "14px 16px",
                                        fontSize: "13px",
                                        color: "#475569",
                                      }}
                                    >
                                      <div>
                                        {formatAmount(
                                          (amount * gstVal) / 2 / 100,
                                        )}
                                      </div>
                                      <div
                                        className="text-muted"
                                        style={{ fontSize: "11px" }}
                                      >
                                        ({gstVal / 2}%)
                                      </div>
                                    </td>
                                  </>
                                )}
                                <td
                                  className="text-end"
                                  style={{
                                    padding: "14px 16px",
                                    fontSize: "13.5px",
                                    color: "#0f172a",
                                    fontWeight: 700,
                                  }}
                                >
                                  {getAmountWithGst(gstVal, amount)}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan={
                                isService
                                  ? pageStates?.purchaseData?.gstType ===
                                    "CGST + SGST"
                                    ? 10
                                    : 9
                                  : pageStates?.purchaseData?.gstType ===
                                    "CGST + SGST"
                                  ? 9
                                  : 8
                              }
                              className="text-center py-4 text-muted small fw-bold"
                            >
                              No Line Items Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                      <tfoot
                        style={{
                          background: "#f8fafc",
                          borderTop: "2px solid #e2e8f0",
                        }}
                      >
                        <tr className="fw-bold">
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "13px",
                              color: "#0f172a",
                            }}
                          >
                            Total
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          {isService && <td></td>}
                          <td></td>
                          <td
                            className="text-end"
                            style={{
                              padding: "12px 16px",
                              fontSize: "13.5px",
                              color: "#0f172a",
                            }}
                          >
                            {formatAmount(totalAmount)}
                          </td>
                          {pageStates?.purchaseData?.gstType === "IGST" && (
                            <td
                              className="text-end"
                              style={{
                                padding: "12px 16px",
                                fontSize: "13.5px",
                                color: "#0f172a",
                              }}
                            >
                              {formatAmount(totalAmountWithGST)}
                            </td>
                          )}
                          {pageStates?.purchaseData?.gstType ===
                            "CGST + SGST" && (
                            <>
                              <td
                                className="text-end"
                                style={{
                                  padding: "12px 16px",
                                  fontSize: "13.5px",
                                  color: "#0f172a",
                                }}
                              >
                                {formatAmount(totalAmountWithGST / 2)}
                              </td>
                              <td
                                className="text-end"
                                style={{
                                  padding: "12px 16px",
                                  fontSize: "13.5px",
                                  color: "#0f172a",
                                }}
                              >
                                {formatAmount(totalAmountWithGST / 2)}
                              </td>
                            </>
                          )}
                          <td
                            className="text-end"
                            style={{
                              padding: "12px 16px",
                              fontSize: "13.5px",
                              color: "#0f172a",
                              fontWeight: 700,
                            }}
                          >
                            {formatAmount(totalAmount + totalAmountWithGST)}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              );
            },
          )
        ) : (
          <div className="card border-0 shadow-sm rounded-3 p-5 text-center bg-white mb-4">
            <span style={{ fontSize: "2rem" }}>📦</span>
            <h6 className="fw-bold mt-2 text-dark">No Items Found</h6>
            <p className="text-muted small mb-0">
              This purchase order does not contain any item details.
            </p>
          </div>
        )}

        {/* Financial Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "18px" }}>💰</span>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Financial Summary
                </h5>
              </div>
              <div>
                <span className="text-secondary small fw-medium">
                  All amounts in INR (₹)
                </span>
              </div>
            </div>

            <div className="row justify-content-end pt-3">
              <div className="col-12 col-md-7 col-lg-5">
                <div className="d-flex flex-column gap-2.5">
                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded-2"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <span
                      className="text-secondary fw-semibold"
                      style={{ fontSize: "14px" }}
                    >
                      Remaining Payable Amount:
                    </span>
                    <span
                      className="fw-bold text-dark"
                      style={{ fontSize: "15px" }}
                    >
                      {formatAmount(
                        pageStates?.purchaseData?.remainingAmount || 0,
                      )}
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded-2 mt-1"
                    style={{
                      background: "#f0fdf4",
                      border: "1px solid #bbf7d0",
                    }}
                  >
                    <div>
                      <div
                        className="text-uppercase"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          color: "#166534",
                          letterSpacing: "0.04em",
                        }}
                      >
                        Grand Total Amount
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: "11.5px" }}
                      >
                        Total Order Value including GST
                      </div>
                    </div>
                    <div className="text-end">
                      <span
                        className="fw-bold"
                        style={{ fontSize: "1.35rem", color: "#15803d" }}
                      >
                        {formatAmount(calculateGrandTotal())}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Payment Tickets Section */}
        {(pageStates?.purchaseData?.status?.includes("Approved") ||
          pageStates?.purchaseData?.status?.includes("Director Created") ||
          pageStates?.purchaseData?.status?.includes("Short Closed")) && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
            style={{ background: "#ffffff" }}
          >
            <div
              className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-2">
                <div
                  className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                  style={{ background: "#f1f5f9", color: "#475569" }}
                >
                  <span style={{ fontSize: "15px" }}>🧾</span>
                </div>
                <div>
                  <h5
                    className="mb-0 fw-bold text-dark"
                    style={{ fontSize: "15px" }}
                  >
                    Payment Tickets
                  </h5>
                </div>
              </div>
              <span
                className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
                style={{ fontSize: "12px", fontWeight: 600 }}
              >
                {pageStatesPT?.PaymentTicketList?.length || 0} Tickets
              </span>
            </div>
            <div className="card-body p-3">
              <CommonTable
                TableHeading={TableHeadingAgainstPo}
                TableData={pageStatesPT?.PaymentTicketList}
                ActionData={ActionData}
                isLoading={pageStatesPT?.tableLoader}
              />
            </div>
          </div>
        )}

        {/* Goods Received Note (GRN) Section */}
        {pageStates?.purchaseData?.canViewGRN &&
          userDetails?.designation?.canCreate?.includes("grn") && (
            <div
              className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                    style={{ background: "#f1f5f9", color: "#475569" }}
                  >
                    <span style={{ fontSize: "15px" }}>📦</span>
                  </div>
                  <div>
                    <h5
                      className="mb-0 fw-bold text-dark"
                      style={{ fontSize: "15px" }}
                    >
                      Goods Received Notes (GRN)
                    </h5>
                  </div>
                </div>
                <span
                  className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
                  style={{ fontSize: "12px", fontWeight: 600 }}
                >
                  {pageStatesGRN?.GRN_List?.length || 0} Notes
                </span>
              </div>
              <div className="card-body p-3">
                <CommonTable
                  TableHeading={TableHeadingForGRN}
                  TableData={pageStatesGRN?.GRN_List}
                  ActionData={ActionDataForGRN}
                  isLoading={pageStatesGRN?.tableLoader}
                />
              </div>
            </div>
          )}

        {/* Description & Supporting Documents Section */}
        <div className="row g-4 mb-4">
          {/* Attached Documents Card */}
          <div className="col-12 col-lg-5">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span
                    style={{
                      fontSize: "16px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: 1,
                      transform: "translateY(-2px)",
                    }}
                  >
                    📎
                  </span>
                  <h5
                    className="mb-0 fw-bold"
                    style={{ fontSize: "14.5px", color: "#0f172a" }}
                  >
                    Documents
                  </h5>
                </div>
                <span
                  className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill"
                  style={{ fontSize: "11px" }}
                >
                  {pageStates?.purchaseData?.documents?.length || 0} Files
                </span>
              </div>
              <div className="card-body p-4">
                {pageStates?.purchaseData?.documents &&
                pageStates.purchaseData.documents.length > 0 ? (
                  <div className="d-flex flex-column gap-2">
                    {pageStates.purchaseData.documents.map((doc, index) => (
                      <div
                        key={doc.id || index}
                        role="button"
                        onClick={() => handleDocumentClick(doc)}
                        className="p-3 rounded-2 d-flex align-items-center justify-content-between gap-3 text-decoration-none shadow-sm"
                        style={{
                          background: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2 overflow-hidden">
                          <div
                            className="rounded-2 p-1.5 d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{
                              background: "#eff6ff",
                              color: "#2563eb",
                              width: "36px",
                              height: "36px",
                            }}
                          >
                            <DocumentIcon />
                          </div>
                          <div className="overflow-hidden">
                            <div
                              className="text-dark fw-semibold text-truncate small"
                              title={doc?.name || "Document"}
                            >
                              {doc?.name || "Document"}
                            </div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "11px" }}
                            >
                              {doc?.updatedAt
                                ? moment(doc?.updatedAt).format(
                                    "DD MMM YYYY | h:mm a",
                                  )
                                : "Attached Document"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="text-muted small py-4 text-center"
                    style={{
                      background: "#f8fafc",
                      borderRadius: "8px",
                      border: "1px dashed #cbd5e1",
                    }}
                  >
                    No Document Found
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Description Card */}
          <div className="col-12 col-lg-7">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center gap-2 border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                    transform: "translateY(-2px)",
                  }}
                >
                  📝
                </span>
                <h5
                  className="mb-0 fw-bold"
                  style={{ fontSize: "14.5px", color: "#0f172a" }}
                >
                  Description
                </h5>
              </div>
              <div className="card-body p-4">
                <div
                  className="p-3 rounded-2"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minHeight: "100px",
                  }}
                >
                  <CKEditor
                    editor={ClassicEditor}
                    data={pageStates?.purchaseData?.description || ""}
                    disabled={true}
                    config={{
                      toolbar: [],
                      readOnly: true,
                      image: {
                        toolbar: [
                          "imageStyle:alignLeft",
                          "imageStyle:alignCenter",
                          "imageStyle:alignRight",
                          "|",
                          "imageTextAlternative",
                        ],
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Action Bar */}
        {hasAnyAction && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 p-3 d-flex flex-row align-items-center justify-content-between flex-wrap gap-3"
            style={{
              background: "#ffffff",
              borderLeft: "4px solid #4f46e5",
            }}
          >
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                className="text-secondary small fw-bold text-uppercase"
                style={{ letterSpacing: "0.04em" }}
              >
                Current Status:
              </span>
              <div>
                {HandlePurchaseRequestStatus(pageStates?.purchaseData?.status)}
              </div>
            </div>
            <div>{renderActionButtons("md")}</div>
          </div>
        )}

        {/* Audit Trail & Activity Logs */}
        <Logs
          type={"purchase"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </div>

      {/* Modals */}
      <ApproveRejectModal
        modal={modal}
        toggle={toggle}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject"
              ? "Rejected"
              : modalType === "shortClose"
              ? "Short Closed"
              : modalType === "hold"
              ? "Hold"
              : "Approved",
            reason,
          )
        }
        isLoading={pageStates.loading}
        actionType={modalType}
      />
      <ViewDocumentModal
        modal={documentModal}
        toggle={toggleDocumentModal}
        selectedDocument={selectedDocument}
      />

      <Modal
        isOpen={increaseBudgetModal}
        toggle={toggleIncreaseBudgetModal}
        centered
      >
        <ModalBody className="text-center">
          <div className="d-flex flex-column justify-content-center align-items-center gap-4 py-4">
            <h4 className="mb-4 text-center">
              Are you sure you want to send a budget increase request?
            </h4>
            <div className="row m-0 w-100">
              <div className="col-12 col-md-6 ps-0 pe-3">
                <button
                  type="button"
                  className="btn btn-secondary w-100"
                  onClick={toggleIncreaseBudgetModal}
                >
                  Cancel
                </button>
              </div>
              <div className="col-12 col-md-6 pe-0 ps-3">
                <button
                  className="btn btn-warning w-100"
                  onClick={() => handleIncreaseSiteBudget()}
                  disabled={pageStates?.IncreaseLoading}
                >
                  {pageStates?.IncreaseLoading ? (
                    <Spinner size="sm" />
                  ) : (
                    "Confirm"
                  )}
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
